import React from 'react';
import PropTypes from 'prop-types';

const TypeDetailsLabel = ({typeDetails}) => {
  if(!typeDetails){
    return null
  }
  return <span>{[typeDetails.MakeName, typeDetails.RangeName, typeDetails.TypeName].filter(v => v).join(' ')}</span>;
};

TypeDetailsLabel.propTypes = {
  typeDetails: PropTypes.shape({
    MakeName: PropTypes.string,
    RangeName: PropTypes.string,
    TypeName: PropTypes.string,
  }),
};

export default TypeDetailsLabel;